module.exports = __webpack_public_path__ + "static/team-values-bbd8e3328c656f84f3bd963a361deb37.svg";